import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';
import { PageDataPanelComponent } from '../../../shared/page-layout/page-data-panel.component';
import { HrTimesheet } from '../../../hr/hr.models';
import { MyHrWorkspaceService } from '../shared/my-hr-workspace.service';
import { labelize, statusSeverity } from '../shared/my-hr-workspace.utils';

@Component({
  selector: 'app-my-hr-timesheets',
  standalone: true,
  imports: [CommonModule, TableModule, TagModule, PageDataPanelComponent],
  templateUrl: './my-hr-timesheets.component.html',
  styleUrls: ['./my-hr-timesheets.component.scss']
})
export class MyHrTimesheetsComponent implements OnInit {
  private readonly workspaceService = inject(MyHrWorkspaceService);

  timesheets: HrTimesheet[] = [];

  ngOnInit(): void {
    this.workspaceService.loadTimesheets().subscribe({
      next: timesheets => {
        this.timesheets = timesheets;
      },
      error: () => {
        this.timesheets = [];
      }
    });
  }

  get totalHours(): number {
    return this.timesheets.reduce((total, timesheet) => total + Number(timesheet.regularHours || 0) + Number(timesheet.overtimeHours || 0), 0);
  }

  label(value?: string): string {
    return labelize(value);
  }

  statusSeverity(value?: string): 'success' | 'secondary' | 'info' | 'warn' | 'danger' {
    return statusSeverity(value);
  }
}
